<template>

    <div class="page-center content-load animated fadeIn">

        <div class="container">
            <div class="row">
                <div class="col-xs-12 col-xl-4 col-lg-4 col-xl-offset-4 col-lg-offset-4 col-md-6 col-md-offset-3">

                    <div class="login-register-page">

                        <center>
                            <img src="static/config/logo.png" style="width: 200px !important" class="logo margin-bottom-15">
                        </center>                        
                        
                        <div class="welcome-text margin-bottom-15 margin-top-5">
                            <h3 class="margin-bottom-20">
                                <i class="las la-id-card"></i>
                                Crie sua conta abaixo!
                            </h3>
                            <span>
                                Já possui um cadastro? 
                                <br>
                                <router-link :to="{'name': 'Login'}" class="button small gray margin-top-5">
                                    <i class="las la-user"></i>
                                    <b>Fazer login</b>
                                </router-link>
                            </span>
                        </div>

                        <form method="post" id="register-account-form" v-on:submit.prevent="submit" novalidate="">
                            
                            <div class="dashboard-box mobile margin-top-0">

                                <!-- Headline -->
                                <div class="headline hidden-xl hidden-lg">
                                    <h3><i class="las la-info-circle"></i> Informações gerais</h3>
                                </div>

                                <div class="content with-padding padding-bottom-0">

                                    <div class="row">                                                               
                        
                                        <div class="col-lg-12 col-xs-12">    
                                        </div>
                                        <div class="margin-bottom-10 col-lg-12 col-xs-12">
                                            <div class="section-headline margin-top-0 margin-bottom-0">
                                                <h5>Nome completo <small>(*obrigatório)</small></h5>
                                            </div>  
                                            <div class="input-with-icon-left">
                                                <i class="las la-info-circle"></i>
                                                <input type="text" class="input-text with-border" autocomplete="new-password" v-model="form.nome" name="nome" autocapitalize="words" id="nome" placeholder="Informe seu nome completo" required/>
                                            </div>          
                                        </div>      
                                                                        
                                        <div class="margin-bottom-10 col-lg-11 col-xs-12">
                                            <div class="section-headline margin-top-0 margin-bottom-0">
                                                <h5>E-mail <small>(opcional)</small></h5>
                                            </div>
                                            <div class="input-with-icon-left">
                                                <i class="las la-envelope"></i>
                                                <input type="email" class="input-text with-border" autocomplete="new-password" v-model="form.email" name="email" id="email" placeholder="Informe seu e-mail" required/>
                                            </div>              
                                        </div>  
                                                                        
                                        <div class="margin-bottom-10 col-lg-9 col-xs-10">
                                            <div class="section-headline margin-top-0 margin-bottom-0">
                                                <h5>Telefone <small>(*obrigatório)</small></h5>
                                            </div>
                                            <div class="input-with-icon-left">
                                                <i class="las la-phone"></i>
                                                <the-mask :mask="['(##) #####-####','(##) ####-####']"  type="tel" class="with-border input-text" placeholder="Informe seu telefone" autocomplete="new-password" v-model="form.telefone" />
                                            </div>
                                        </div>
                                                                        
                                        <div class="margin-bottom-10 col-lg-8 col-xs-10">
                                            <div class="section-headline margin-top-0 margin-bottom-0">
                                                <h5>CPF <small>(*obrigatório)</small></h5>
                                            </div>
                                            <div class="input-with-icon-left">
                                                <i class="las la-id-card"></i>
                                                <the-mask :mask="['###.###.###-##']" type="tel" class="input-text with-border" autocomplete="new-password" v-model="form.doc" placeholder="Informe seu CPF" required />
                                            </div>                      
                                        </div>

                                        <div class="margin-bottom-10 col-lg-8 col-xs-10">
                                            <div class="section-headline margin-top-0 margin-bottom-0">
                                                <h5>Data de nascimento <small>(*obrigatório)</small></h5>
                                            </div>
                                            <div class="input-with-icon-left">
                                                <i class="las la-calendar-alt"></i>
                                                <the-mask :mask="['##/##/####']" :masked="true" type="tel" class="input-text with-border" autocomplete="new-password" v-model="form.dataNascimento" placeholder="___ /____ /_____" required />
                                            </div>                      
                                        </div>

                                        <div class=" margin-bottom-0 col-lg-10 col-xs-10">
                                            <div class="section-headline margin-top-0 margin-bottom-5">
                                                <h5 class="margin-bottom-0">Convênio <small>(*obrigatório)</small></h5>
                                                <small style="margin-top: -10px; display: block;">Selecione o seu convênio abaixo:</small>
                                            </div>
                                            <div class="input-with-icon-left">
                                                <i class="las la-id-card-alt"></i>
                                                <select class="with-border" name="convenio" v-model="form.convenio" style="padding-left: 0px !important; text-indent: 50px !important;">
                                                    <option disabled readonly default value="">Selecione aqui..</option>
                                                    <!-- <option value="NENHUM">NENHUM</option> -->
                                                    <option :value="item.DS_CONVENIO" v-for="(item, index) in convenios.itens">{{item.DS_CONVENIO}}</option>
                                                </select>
                                            </div>                      
                                        </div>                                            
                                       
                                        
                                        <div class=" col-xl-9 col-xs-10">
                                            <div class="section-headline margin-top-0 margin-bottom-0">
                                                <h5>Senha <small>(*obrigatório)</small></h5>
                                            </div>
                                            <div class="input-with-icon-left" title="Pelo menos 8 caracteres" data-tippy-placement="bottom">
                                                <i class="las la-lock"></i>
                                                <input type="password" class="input-text with-border" autocomplete="new-password" v-model="form.senha" name="senha" id="password-register" placeholder="Informe uma senha" required/>
                                            </div>
                                        </div>
                                        <div class=" margin-bottom-10 col-xl-9 col-xs-10">
                                            <div class="input-with-icon-left">
                                                <i class="las la-lock"></i>
                                                <input type="password" class="input-text with-border" autocomplete="new-password" v-model="form.senhaConfirmacao" name="senhaConfirmacao" id="password-repeat-register" placeholder="Repita sua senha" required/>
                                            </div>
                                        </div>
                                        <div class="col-xl-12 margin-top-10">
                                            <div class="checkbox">
                                                <input type="checkbox" id="enviarEmailSMS" v-model="form.enviarEmailSMS" true-value="1" false-value="0">
                                                <label for="enviarEmailSMS"><span class="checkbox-icon"></span>  Desejo receber notificações por<br><b>e-mail</b> e <b>SMS</b>.</label>
                                            </div>
                                            <hr style="" class="margin-top-15">
                                        </div>

<!--                                         <div class="col-xl-12 col-lg-12 center margin-top-15">
                                            <p class="margin-bottom-0">
                                                <i class="material-icons" style="font-size: inherit;">check</i>
                                                Ao prosseguir, você concorda com os nossos <a v-on:click="$root.openModal('modal-termos-de-uso')"><b>Termos de Uso</b></a> e a <a v-on:click="$root.openModal('modal-politicas-de-privacidade')"><b>Política de Privacidade</b></a>.
                                            </p>
                                        </div> -->
                                        <div class="col-lg-12 col-xs-12 margin-top-20 margin-bottom-20">
                                            <button class="button full-width color-secondary" v-bind:class="{'disabled': loading.submit}" type="submit">
                                                <i class="las la-lock"></i>
                                                <span v-show="!loading.submit">Cadastrar</span>
                                                <span v-show="loading.submit">Cadastrando</span>
                                            </button>
                                            <a class="button block-mobile margin-top-10" v-on:click="$root.back();" style="opacity: 0.7; display: block; text-align: center;">
                                                <i class="las la-arrow-left"></i>
                                                Voltar
                                            </a>
<!--                                             <span class="selo margin-top-10">
                                                <i class="material-icons">check_circle</i>
                                                Você está em um ambiente seguro.
                                            </span>   -->                                                                                              
                                        </div>
                                    </div>
                                </div>
                            </div>
                        

                        </form>

                        
                    </div>

                </div>
            </div>
        </div>  


    </div>
</template>

<script>
export default {
    name:                           'Cadastro',
    data () {
        var self                    = this;
        return {
            campoTermos:            "",
            loading: {
                "submit":           false,
            },
            convenios:              {
                "itens":            [],
                "loaded":           false
            },
            form: {
                "nome":             null,
                "email":            null,
                "tipo":             "contratante",
                "telefone":         null,
                "doc":              "",
                "convenio":         "",
                "termos":           false,
                "termosDatahora":   null,
                "politicas":        false,
                "politicasDatahora":null,                
                "dataNascimento":   null,
                "senha":            null,
                "senhaConfirmacao": null,
                "enviarEmailSMS":   1,
                "dispositivo":      self.$root.mobile.osName
            }
        }
    },
    methods: {
        aceitarTermos: function() {
            var self = this;
            console.log("aceitarTermos");
            self.form[window.termos.campo] = true;
            if (window.__app.modal["modal-termos-de-uso"]) window.__app.modal["modal-termos-de-uso"].close();
            if (window.__app.modal["modal-politicas-de-privacidade"]) window.__app.modal["modal-politicas-de-privacidade"].close();

            self.submit();
        },
        negarTermos: function() {
            var self = this;
            console.log("negarTermos");
            self.form[window.termos.campo] = false;
            if (window.__app.modal["modal-termos-de-uso"]) window.__app.modal["modal-termos-de-uso"].close();
            if (window.__app.modal["modal-politicas-de-privacidade"]) window.__app.modal["modal-politicas-de-privacidade"].close();

            alert("Para prosseguir com o seu cadastro é necessário aceitar os termos apresentados.");
        },        
        getConvenios: function() {
            var self        = this;
            console.log("getConvenios()", self.form);
            loading.show();
            return new Promise(function(resolve, reject) {

                axios.get("api/convenios.php", {params: self.form})
                .then(response => {
                    
                    console.log("getConvenios() response", response);
                    self.convenios  = JSON.parse(JSON.stringify(response.data.result));
                    self.$forceUpdate(); 
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("getConvenios() error", error.response);                    
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });   
            });   
        },         
        submit: function(e) {
            var self            = this;
           
            if (e) e.preventDefault();

            if (!self.form.termos) {
                window.termos.campo = "termos";
                self.$root.openModal('modal-termos-de-uso', null, true);
            } else if (!self.form.politicas) {
                window.termos.campo = "politicas";
                self.$root.openModal('modal-politicas-de-privacidade', null, true);
            } else {

                console.log("passou", self.form);
                // return false;

                self.loading.submit = true;
                loading.show();
                axios.post("api/cadastro.php", self.form)
                .then(response => {
                    // self.loading.submit = false;
                 
                    if (response.data.user) {
                        self.$root.setUser(response.data.user).then(function() {
                            setTimeout(function() {
                                window.location.reload();
                            }, 200);
                        })
                    } else {
                        loading.hide();
                    }
                })
                .catch(error => {
                    loading.hide();
                    self.loading.submit = false;
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                    if (error.response) {
                        if (error.response.data.message == "O seu CPF já está cadastrado no aplicativo. Por favor, faça login para continuar.") {
                            self.$router.push({"name": "Login"});
                        }
                    }
                });
            }

        }
    },
    created: function() {
        var self = this;
        window.termos = {
            aceitar:    self.aceitarTermos,
            negar:      self.negarTermos
        };
        loading.show();
        Promise.all([
            self.getConvenios(),
        ]).then(function() {
            loading.hide();
        }).catch(function(error) {
            loading.hide();
        });          
    },
    mounted: function() {
        var self = this;
        // loading.hide();
    } 
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style >
    .page-cadastro .section-headline h5 {
        font-weight: 400;
    }
    .page-cadastro .section-headline h5 small {
        color: #000;
    }
    .current-page-cadastro .loading {
        top: 0px !important;
    }    
/*    .current-page-cadastro {
        background-image: url(static/images/img8.jpg);
        background-size: auto 100%;
        background-repeat: no-repeat;
        background-position: 70%;
    }*/
    .page-cadastro #wrapper {
        background: rgba(255,255,255,0.85);
        padding-top: 0px !important;
        padding-bottom: 0px !important;
    }
    .page-cadastro .container {
        margin-top: 35px !important;
        padding-left: 20px;
        padding-right: 20px;
        margin-bottom: 20px;
    }
    .page-cadastro input {
        margin-bottom: 5px;
    }
    .page-cadastro .input-with-icon-left i {
        background: #efefef;
    }
    .page-cadastro .selo {
        /*position: absolute;*/
        bottom: 0px;
        width: 100%;
        display: block;
        margin-top: 0px;
        text-transform: uppercase;
        font-size: 10px;
        margin-bottom: 10px;
        text-align: center;
        letter-spacing: 0px;
        color: #444;
    }
    .page-cadastro .section-headline {
        padding-right: 0px;
    }
    .page-cadastro .checkbox label {
        font-size: 14px;
        line-height: 130%;    
    }
/*    .page-cadastro .selo i {
        font-size: 14px;
        top: 2px;
        color: #00995d;
        position: relative;
    }    
    .page-cadastro .input-with-icon-left i {
        color: #00995d;
    }
    .page-cadastro h3 i {
        color: #00995d;
    }           
    .page-cadastro .checkbox input:checked+label span.checkbox-icon {
        background-color: #00995d;
        border-color: #00995d;
    }*/




</style>



// WEBPACK FOOTER //
// src/components/Cadastro.vue